import React, {Component} from 'react'
import {BrowserRouter, NavLink, Route, Switch, withRouter} from 'react-router-dom'
import {initKeycloakSession} from './actions/keycloak-actions'
import {connect} from 'react-redux'
import {Grid} from 'react-bootstrap'
import classnames from 'classnames'
import {NotificationContainer} from 'react-notifications'
import 'react-notifications/lib/notifications.css'

import Collaborators from './pages/Collaborators'
import OrganizationsOverview from './pages/OrganizationsOverview'
import AboutPages from './pages/AboutPages'
import Results from './pages/Results'
import Overview from './pages/Overview'
import Account from './pages/Account'
import Locations from './pages/Locations'
import NewScan from './pages/NewScan'
import CoreQuestions from './pages/Scan/CoreQuestions.js'
import IntroQuestions from './pages/Scan/IntroQuestions.js'
import ScanOverview from './pages/ScanOverview'
import Analysis from './pages/Analysis'
import TourModal from './pages/Tour'
import LogoutModal from './components/LogoutModal'

import logo from './logo.svg'
import ApplicationContext from './context/ApplicationContext'

class SidebarCollapse extends Component {
  constructor(props) {
    super(props)
    this.changeState = this.changeState.bind(this)
  }

  changeState(submenu) {
    if (window.sessionStorage.getItem('submenu') === 'true') {
      window.sessionStorage.setItem('submenu', JSON.stringify(false))
    } else {
      window.sessionStorage.setItem('submenu', JSON.stringify(true))
    }
  }

  /* This error is being thrown by the href="#" in the link tags because create-react-app warns designers against bad practices. 
      Designers usually use href="#" as placeholder for links but create-react-app warns us that we should change it to an 
      actual route because it doesn't do anything and we might have made a mistake. */
  render() {
    return <li className='sidebar-collapse' onClick={() => this.changeState() }>
      <a className={classnames({'account': true, 'active': window.sessionStorage.getItem('submenu') === 'true', 'in-active': !window.sessionStorage.getItem('submenu') === 'true'})}
         href='#'><span>{this.props.title}</span></a>
      {window.sessionStorage.getItem('submenu') === 'true' && this.props.children}
    </li>
  }
}

const SidebarItem = ({path, className, title, exact}) => <li onClick={ActiveEvent}>
  <NavLink to={path} className={className} activeClassName='active' exact={exact}><span>{title}</span></NavLink>
</li>

const SubSidebarItem = ({path, className, title}) => <li onClick={ActiveSubEvent}>
  <NavLink to={path} className={className} activeClassName='active'><span>{title}</span></NavLink>
</li>

const ActiveEvent = () => {
  window.sessionStorage.setItem('submenu', JSON.stringify(false))
}

const ActiveSubEvent = () => {
  window.sessionStorage.setItem('submenu', JSON.stringify(true))
}

const setcookie = ""
const currentcookie = document.cookie

class App extends Component {
  constructor(props) {
    super(props)
    props.initKeycloakSession(props.keycloakSession)
    this.showTourModal = this.showTourModal.bind(this)
    this.hideLogoutModal = this.hideLogoutModal.bind(this)
    this.printWindow = this.printWindow.bind(this)
    this.state = {
      showTour: false,
      collapseSidebar: false,
      showLogoutModal: false,
      autoShowTour: true
    }
    this.getData = this.getData.bind(this)
  }

  toggleSidebar() {
    this.setState({collapseSidebar: !this.state.collapseSidebar})
  }

  logout() {
    this.setState({showLogoutModal: true})
  }

  hideLogoutModal() {
    this.setState({showLogoutModal: false})
  }

  showTourModal() {
    this.setState({showTour: true})
  }

  hideTourModal() {
    this.setState({
      showTour: false,
      autoShowTour: false
    })
  }

  printWindow() {
    window.print()
  }

  getData(val) {
    // setcookie is never used: const setcookie = val
  }

  render() {
    const isAdmin = this.props.keycloakSession.hasRealmRole('admin')

    return (
      <BrowserRouter>
        <ApplicationContext>
          <Grid fluid={true}>
            <div id="sidebar" className={classnames('nav', {collapsed: this.state.collapseSidebar})}>
              <div className="logo"><img src={logo} alt="logo"/></div>
              <div id="navigation">
                <div className="nav-group">
                  <ul>
                    <SidebarItem path='/' component={Overview} className="dashboard" title='Overzicht' exact/>
                    <SidebarItem path='/results' className="results" title='Resultaten'/>
                    <SidebarItem path='/analysis' className="analysis" title='Analyse'/>
                  </ul>
                </div>
                <div className="nav-group">
                  <ul>
                    <SidebarItem path='/scans' className="scans" title='Scans'/>
                    <SidebarItem path='/newscan' className="new-scan" title='Nieuwe scan'/>
                  </ul>
                </div>
                <div className="nav-group">
                  <ul>
                    <SidebarItem path='/organizations' component={OrganizationsOverview} className="units"
                                 title='Organisatie'/>

                  </ul>
                </div>
                <div className="nav-group last">
                  <ul>
                    { /* BW-201 Temporary disabled
                      <li>
                        <button className="print" onClick={() => this.printWindow()}>Printen</button>
                      </li>
                    */ }
                    <SidebarCollapse title='Account'>
                      <ul>
                       {isAdmin &&
                         <SubSidebarItem path='/account' component={Account} className="account" title='Account'/>
                       }
                        <li>
                          <button onClick={this.showTourModal}>Rondleiding</button>
                        </li>
                        <SubSidebarItem path='/about' title='Over BrandWijzer'/>
                        <li>
                          <button onClick={() => this.logout()}>Uitloggen</button>
                        </li>
                      </ul>
                    </SidebarCollapse>
                  </ul>
                </div>
                <div className={classnames('nav-group toggle-sidebar', {active: this.state.collapseSidebar})}
                     onClick={() => this.toggleSidebar()}>
                  <NavLink to="#"></NavLink>
                </div>
              </div>
            </div>

            <div id="main-content" className={classnames('main', {collapsed: this.state.collapseSidebar})}>
              {/* Main content */}
              {!this.props.error && <Switch>
                <Route exact path='/' component={Overview}/>
                <Route exact path='/results' component={Results}/>
                <Route exact path='/results/:scanId' component={Results}/>
                <Route exact path='/analysis' component={Analysis}/>
                <Route exact path='/analysis/:scanId' component={Analysis}/>
                <Route exact path='/scans' component={ScanOverview}/>
                <Route exact path='/scans/:scanId' component={IntroQuestions}/>
                <Route exact path='/scans/:scanId/next' component={CoreQuestions}/>
                <Route exact path='/newscan' component={NewScan}/>
                <Route exact path='/organizations' component={OrganizationsOverview}/>
                <Route exact path='/collaborators' component={Collaborators}/>
                <Route exact path='/account' component={Account}/>
                <Route exact path='/locations' component={Locations}/>
                <Route exact path='/about' component={AboutPages}/>
              </Switch>
              }
              {setcookie === currentcookie &&
              <TourModal sendData={this.getData} selfTriggered='false' hideTourModal={() => this.hideTourModal()}
                         show={this.state.autoShowTour}/>}
              <div>{this.state.showTour && <TourModal selfTriggered='true' hideTourModal={() => this.hideTourModal()}
                                                      show={this.state.showTour}/>}</div>
            </div>

            {this.state.showLogoutModal &&
            <LogoutModal logout={() => this.props.onLogout()} hideLogoutModal={() => this.hideLogoutModal()}
                         show={this.state.showLogoutModal}/>}

          </Grid>
          <NotificationContainer/>
        </ApplicationContext>
      </BrowserRouter>
    )
  }
}

export default withRouter(connect((state) => {
  return {}
}, {initKeycloakSession})(App))


// WEBPACK FOOTER //
// ./src/App.js